import {
  EcommerceProductsAction, LOAD_ECOMMERCE_ORDER, LOAD_ECOMMERCE_ORDER_FAIL, LOAD_ECOMMERCE_ORDER_SUCCESS,
  LOAD_ECOMMERCE_ORDERS,
  LOAD_ECOMMERCE_ORDERS_FAIL,
  LOAD_ECOMMERCE_ORDERS_SUCCESS, LoadEcommerceOrder, LoadEcommerceOrderFails, LoadEcommerceOrdersFails,
  LoadEcommerceOrdersSuccess, LoadEcommerceOrderSuccess,
} from "../actions";
import {IOrder} from "../../websites/website/ecommerce/orders/orders.interface";
import {ICustomer} from "../../websites/website/ecommerce/ecommerce-customer.interface";
import {RefundData} from "../../websites/website/ecommerce/orders/mapper/refund-data";

export interface IEcommerceOrdersEntityState {
  orders: IOrder[];
  order: {
    order: IOrder,
    customer: {} & { date_created: { date: string }, email: string, customer_id: number },
    refunds: RefundData[]
  };
  customers: ICustomer[];
  ordersCount: number;
  loading: boolean;
  loaded: boolean;
  failed: boolean;
}

export interface IEcommerceOrdersState {
  entities: { [websiteId: number]: IEcommerceOrdersEntityState };
  loading: boolean;
  loaded: boolean;
}

export const initialState: IEcommerceOrdersState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IEcommerceOrdersState = initialState, action: EcommerceProductsAction): IEcommerceOrdersState {
  let payload: any;

  switch (action.type) {

    case  LOAD_ECOMMERCE_ORDERS:
      payload = (<LoadEcommerceOrdersSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_ORDERS_SUCCESS:
      payload = (<LoadEcommerceOrdersSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            orders: payload.entities.orders,
            customers: payload.entities.customers,
            ordersCount: payload.ordersCount,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_ORDERS_FAIL:
      payload = (<LoadEcommerceOrdersFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_ORDER:
      payload = (<LoadEcommerceOrder>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state[payload.websiteId],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_ECOMMERCE_ORDER_SUCCESS:
      payload = (<LoadEcommerceOrderSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            order: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_ECOMMERCE_ORDER_FAIL:
      payload = (<LoadEcommerceOrderFails>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true,
            failed: true
          }
        }
      };
  }

  return state;
}
